var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41158 7.24986C7.41158 7.24986 4.90991 7.52694 3.24108 7.71219C3.09066 7.7304 2.95766 7.83094 2.90779 7.98373C2.85791 8.13653 2.90779 8.29565 3.01862 8.39619C4.25837 9.52748 6.12116 11.2217 6.12116 11.2217C6.11958 11.2217 5.60974 13.6861 5.27091 15.3304C5.24241 15.4792 5.29624 15.6368 5.42608 15.731C5.55512 15.8252 5.72137 15.8268 5.85199 15.7532C7.31183 14.9235 9.49841 13.6758 9.49841 13.6758C9.49841 13.6758 11.6858 14.9235 13.1432 15.7539C13.2762 15.8268 13.4425 15.8252 13.5715 15.731C13.7014 15.6368 13.7552 15.4792 13.7259 15.3312C13.3871 13.6861 12.878 11.2217 12.878 11.2217C12.878 11.2217 14.7408 9.52748 15.9806 8.39857C16.0914 8.29486 16.1405 8.13573 16.0914 7.98373C16.0423 7.83173 15.9093 7.73119 15.7589 7.71378C14.0901 7.52694 11.5876 7.24986 11.5876 7.24986C11.5876 7.24986 10.5505 4.95561 9.85941 3.42611C9.7945 3.28915 9.65833 3.19336 9.49841 3.19336C9.33849 3.19336 9.20154 3.28994 9.13979 3.42611C8.44787 4.95561 7.41158 7.24986 7.41158 7.24986Z",
    fill: "#FEB41D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5df17d2b4b58d574f9ce66fec083b607.svg";
export { ForwardRef as ReactComponent };